export default "__VITE_ASSET__b7f818ed__"